<template>
  <b-form-group :label="title" label-class="label-style" :description="labelPeriod">
    <flat-pickr id="input-start-date" v-model="startDate" class="custom-select" :config="configFlatPickr"
      @on-change="updateManualStart" />
  </b-form-group>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { dateFormatEnum } from "@/filter/dateFormat";
import Tools from "@/utils/tools";

export default {
  name: "DatePicker",
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    /** Format d'affichage dans le date picker */
    datePickerFormat: {
      type: String,
      default() {
        return dateFormatEnum.DATE_SHORT_FORMAT;
      },
    },
    dateFilterProperty: {
      type: String,
      default() {
        return "";
      },
    },
    dateFilterFormat: {
      type: String,
      default() {
        return dateFormatEnum.SQL_DATE_FORMAT;
      },
    },
  },
  data: function () {
    return {
      startDate: "",
      dateDayFilter: null,
      dateMonthFilter: null,
      dateYearFilter: null,
    };
  },
  computed: mapState({
    configFlatPickr() {
      return Tools.Helper.getFlatPickerConfig(this.datePickerFormat, false);
    },
    pickedDate() {
      return moment(this.startDate, this.datePickerFormat);
    },
    isDateValid() {
      return this.pickedDate && this.pickedDate.isValid();
    },
    labelPeriod() {
      return this.isDateValid
        ? Tools.BusinessDateHelper.getLabelPeriodOneDay(
          this.pickedDate,
          this.$t("filter.period_default_prefix"),
          false,
        )
        : "";
    },
  }),
  mounted: function () {
    this.setDefaultDate();
  },
  methods: {
    updateManualStart(date, str) {
      this.startDate = str;
      this.updateDateFilters();
    },
    formatDateString(date) {
      return moment(date).format(this.datePickerFormat).toString();
    },
    setDefaultDate() {
      this.startDate = this.formatDateString(
        Tools.BusinessDateHelper.getTodaysBusinessDate()
      );
      this.updateDateFilters();
    },
    updateDateFilters() {
      if (this.isDateValid) {
        const date = this.pickedDate
          .format(this.dateFilterFormat)
          .toString();
        this.$emit("dateFiltersUpdated", {
          filters: [
            {
              dimension: this.dateFilterProperty,
              operator: "equals",
              values: [date],
            }
          ],
          pickedDate: this.startDate,
          labelPeriod: this.labelPeriod,
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.flatpickr-input {
  background: none;
}

.flatpickr-confirm {
  background-color: white !important;
}

// Cibler la description du form-group Bootstrap Vue
::v-deep .form-text.text-muted {
  white-space: pre-line !important;
}

.label-style {
  flex: 1;
  text-align: left;
  font-weight: bold;
}
</style>
